module.exports = __webpack_public_path__ + "Poppins-BoldItalic.b854834365f937190b83.woff2";


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/src/assets/vendors/base/fonts/googleapi-fonts/Poppins-BoldItalic.woff2
// module id = ../../../../../src/assets/vendors/base/fonts/googleapi-fonts/Poppins-BoldItalic.woff2
// module chunks = styles